import React from "react";

export default function Footer() {
  return (
    <div className="ml-0 xl:ml-[10%] bg-[var(--yellow)] py-5">
      <p className="text-white text-center text-sm">
        Made with ❤️ by Shanya Sahu
      </p>
    </div>
  );
}
